import React from 'react';
import { Image } from 'react-bootstrap';
import './DisplayItems.scss';

const titleForItem = (title, moreStyle) => {
  return (
    <label
      className={`create-section-label create-section-label-bottom-space ${moreStyle}`}
    >
      {title}
    </label>
  );
};

export const listItem = (title, value, moreStyle) => {
  return (
    <>
      {titleForItem(title, moreStyle)}
      <label className="banners-detail-text">{value || '-'}</label>
    </>
  );
};

export const listImage = (title, src) => {
  return (
    <>
      {titleForItem(title)}
      <Image className="feature-campaign-detail-image" src={src} />
    </>
  );
};
